import { createApiClient } from "./lib/apiClient";

const api = createApiClient("/api");

// Sites
export const getSites = () => api.get("/sites");
export const getSite = (id) => api.get(`/sites/${id}`);
export const createSite = (data) => api.post("/sites", data);
export const updateSite = (id, data) => api.put(`/sites/${id}`, data);
export const deleteSite = (id) => api.delete(`/sites/${id}`);
export const getSiteProviders = () => api.get("/sites/providers");
export const validateProviderConfig = (provider, data) =>
  api.post(`/sites/providers/${provider}/validate`, data);
export const deploySite = (siteId, data = {}) =>
  api.post(`/sites/${siteId}/deploy`, data);
export const redeploySite = (siteId, data = {}) =>
  api.post(`/sites/${siteId}/redeploy`, data);
export const getSiteDeployments = (siteId) =>
  api.get(`/sites/${siteId}/deployments`);
export const getDiversityStats = () => api.get("/sites/diversity-score");

// Audits
export const runAudit = (siteId) => api.post(`/audit/${siteId}`);
export const getAudits = (siteId) => api.get(`/audit/${siteId}`);
export const getLatestAudit = (siteId) => api.get(`/audit/${siteId}/latest`);

// Keywords
export const getKeywords = (siteId) => api.get(`/keywords/${siteId}`);
export const addKeyword = (data) => api.post("/keywords", data);
export const deleteKeyword = (id) => api.delete(`/keywords/${id}`);

// Ranks (history). The legacy "simulate" routes
// (POST /ranks/check, POST /ranks/check-all) were removed in favour of
// the DataForSEO routes below — synthetic positions were polluting
// real history and confused users about what the chart represented.
export const getRanks = (keywordId) => api.get(`/ranks/${keywordId}`);

// AI Content
export const generateContent = (data) => api.post("/content/generate", data);

// Ranks - Real SERP (DataForSEO)
export const checkRealPosition = (keywordId) =>
  api.post(`/serp/check-position?keyword_id=${keywordId}`);
export const checkAllPositions = (siteId, searchEngine = "google") =>
  api.post(`/serp/check-all-positions/${siteId}?search_engine=${searchEngine}`);
export const getKeywordData = (keyword) =>
  api.get(`/serp/keyword-data/${encodeURIComponent(keyword)}`);
export const testDataForSEOCredentials = () =>
  api.post("/serp/test-credentials");
export const getDataForSEOCredentialsStatus = () =>
  api.get("/serp/credentials-status");

// IndexNow
export const submitIndexNow = (siteId, urls) =>
  api.post(`/indexnow/submit?site_id=${siteId}`, urls);

// Article Export
export const exportArticle = (articleId, format = "html") =>
  api.get(`/articles/export/${articleId}?format=${format}`);
export const exportAllArticles = (siteId, format = "html") =>
  api.post(`/articles/export-all/${siteId}?format=${format}`);

// Reports
export const generateReport = (siteId, type = "full") =>
  api.post(`/reports/${siteId}?report_type=${type}`);
export const getReports = (siteId) => api.get(`/reports/${siteId}`);

// Dashboard
export const getDashboardStats = () => api.get("/dashboard/stats");

// Admin
export const adminListUsers = (params = {}) =>
  api.get("/admin/users", { params });
export const adminGetUser = (id) => api.get(`/admin/users/${id}`);
export const adminCreateUser = (data) => api.post("/admin/users", data);
export const adminUpdateUser = (id, data) => api.patch(`/admin/users/${id}`, data);
export const adminResetPassword = (id, data) =>
  api.post(`/admin/users/${id}/reset-password`, data);
export const adminDeleteUser = (id, cascade = false) =>
  api.delete(`/admin/users/${id}`, { params: { cascade_data: cascade } });
export const adminImpersonate = (id) =>
  api.post(`/admin/users/${id}/impersonate`);
export const adminGetSettings = () => api.get("/admin/settings");
export const adminUpdateSettings = (data) => api.put("/admin/settings", data);

// Auth — change password / accept invite
export const changePassword = (data) =>
  api.post("/auth/change-password", data);
export const acceptInvite = (data) => api.post("/auth/accept-invite", data);
export const getAcceptInviteInfo = (token) =>
  api.get("/auth/accept-invite-info", { params: { token } });

// Webhook
export const saveWebhook = (data) => api.post("/webhooks/save", data);
export const getWebhookConfig = () => api.get("/webhooks/config");
export const testWebhook = (data) => api.post("/webhooks/test", data);
export const publishArticleWebhook = (articleId) =>
  api.post(`/webhooks/publish/${articleId}`);
export const publishAllWebhook = (siteId) =>
  api.post(`/webhooks/publish-all/${siteId}`);

export default api;
